<template>
    <div class="py-3 px-5" style="background-color: #f5f5f5;height: 98.3vh;">
        <div class="col-12 text-start mx-auto">
            <img src="../../public/img/logo-white.png" style="width: 100px;cursor: pointer;" alt="" @click="router.push({name:'home'})">
        </div>
        <div class="col-md-5 col-sm-9 col-11 mx-auto mt-5 pt-5">
            <div class="px-sm-5 my-5">
                <div class="px-sm-5 px-4">
                    <h4 class="text-center">ورود</h4>
                    <!-- <a class="navbar-brand" href="../"><img src="../../public/img/logo-white.png" style="height: 100px;" alt=""></a> -->
                    <div class="row my-3 text-end">
                        <!-- <lable class="w-100 mt-3">شماره تلفن :</lable> -->
                        <input type="text" name="" id="" class="w-100 py-3" v-model="phone" placeholder="شماره تلفن">
                        <!-- <lable class="w-100 mt-3">پسوورد :</lable> -->
                        <input type="password" name="" id="" class="w-100 mt-3 py-3" v-model="password" placeholder="رمز عبور">
                        <button class="btn-blue mt-4 px-5 fs-6" @click="login1()">ورود</button>
                        <a href="../sign-up" class="mt-4 text-center fs-6">ثبت نام</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { defineComponent, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({

    setup() {
        const phone = ref()
        const password = ref()
        const router = useRouter()
        
        onMounted(() => {
            if (localStorage.getItem('phone')) {
              router.push({'name':'dashboard',params:{id: localStorage.getItem('id')}})
            }
        })

        function login1(){
            if (!phone.value || !password.value) {
            alert("لطفاً شماره تلفن و پسورد را وارد کنید.");
            return;
            }
            else {
                axios.put('https://api.xaifin.com/user/login',{'username':phone.value,'password':password.value}).then((res)=>{
                    if (res.status==200) {
                        localStorage.setItem('phone',phone.value)
                        localStorage.setItem('name',res.data.user.name)
                        localStorage.setItem('family',res.data.user.family)
                        localStorage.setItem('id',res.data.user._id)
                        router.push({'name':'dashboard',params:{id:res.data.user._id}})
                    }
                }).catch((error)=>{                    
                    Swal.fire({
                          text: error.response.data.mess,
                          icon: "error"
                        });
                })
            }
        }

        return{
            phone,
            password,
            router,
            login1
        }
    }

})
</script>
<style scoped lang="scss">

.card-custom {
    box-shadow: 0px 0px 5px 0px #adadad;
    border: none;
    border-radius: 8px;
    background-color: white;
  }
</style>